import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";

import { api } from "../lib/api";
import { RESET_EMAIL_TIPS } from "../lib/passwordRecovery";

import { torneos123HeaderLogoSrc } from "../lib/brandLogo";

export default function RecoverPasswordPage() {
  // Correo O usuario: el servidor acepta los dos (el campo se llama `email`
  // en la API por compatibilidad con la app instalada).
  const [identifier, setIdentifier] = useState("");
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setSubmitting(true);
    try {
      await api.auth.passwordResetRequest(identifier.trim());
    } catch {
      // respuesta neutra también ante error de red: no filtramos nada
    } finally {
      setSent(true);
      setSubmitting(false);
    }
  }

  function tryAnother() {
    setIdentifier("");
    setSent(false);
  }

  return (
    <div className="login-shell">
      <header className="login-shell__brand">
        <img className="login-shell__logo" src={torneos123HeaderLogoSrc()} alt="Torneos123" />
        <p className="login-shell__eyebrow">Compite · Progresa · Gana</p>
        <p className="login-shell__subtitle">Recuperar contraseña</p>
      </header>

      <section className="login-shell__card">
        {sent ? (
          <div className="recover-password__sent" role="status">
            <p>
              Si hay una cuenta con ese correo o usuario, te enviamos un correo con
              un enlace para crear una nueva contraseña. El enlace vence en 60 minutos.
            </p>
            <p className="recover-password__tips-title">Si no te llega en unos minutos:</p>
            <ul className="recover-password__tips">
              {RESET_EMAIL_TIPS.map((tip) => (
                <li key={tip}>{tip}</li>
              ))}
            </ul>
            <button className="btn btn--ghost" type="button" onClick={tryAnother}>
              Probar con otro correo o usuario
            </button>
          </div>
        ) : (
          <form className="form" onSubmit={handleSubmit}>
            <label>
              Tu correo o usuario
              <input
                type="text"
                inputMode="email"
                placeholder="tu@correo.com o tu usuario"
                autoComplete="username"
                autoCapitalize="none"
                autoCorrect="off"
                spellCheck={false}
                required
                value={identifier}
                onChange={(event) => setIdentifier(event.target.value)}
                disabled={submitting}
              />
            </label>
            <p className="recover-password__hint">
              Escribe el correo con el que te inscribiste o tu usuario de Torneos123.
            </p>
            <button className="btn" type="submit" disabled={submitting}>
              {submitting ? "Enviando…" : "Enviarme el enlace"}
            </button>
          </form>
        )}
        <p className="login-shell__helper">
          <Link to="/login">Volver a iniciar sesión</Link>
        </p>
      </section>

      <p className="login-shell__credit">Torneos123 · Sistema de torneos</p>
    </div>
  );
}
